import { UpdateLegalClientBeneficiaryParams } from 'api/types/params';
import { isGlobalProject } from 'config';
import { yesOrNot } from 'helpers';
import {
  parseTaxResidencyParam,
  parsePepConnectionParam,
  parseCitizenshipsParam,
  parseAdditionalInformationFileIdsParam,
  parseAdditionalDocumentFileIdsParam,
  parseAddressWithFilesParam,
} from 'modules/client/common/helpers';
import { parseIdentityDocumentWithFilesParam } from 'modules/client/common/helpers/parseParams/parseIdentityDocumentParam';

import { LegalClientBeneficiaryFormType } from '../../forms/legalClientBeneficiaryForm';

export const getLegalClientBeneficiarySubmitData = (
  versionNumber: number,
  values: LegalClientBeneficiaryFormType
): UpdateLegalClientBeneficiaryParams => {
  const addressParam = parseAddressWithFilesParam(values);

  const isGlobal = isGlobalProject();

  return {
    versionNumber,
    reason: values.reasonChange.reason,
    firstName: values.personalData.firstName,
    lastName: values.personalData.lastName,
    middleName: values.personalData.middleName ?? null,
    dateOfBirth: values.personalData.dateOfBirth,
    citizenships: parseCitizenshipsParam(values),

    registrationAddress: !isGlobal
      ? addressParam.registrationAddress
      : undefined,
    residentialAddress: addressParam.residentialAddress,
    placeOfBirth: addressParam.placeOfBirth,

    taxResidences: parseTaxResidencyParam(values),

    pepConnection: values.pepConnection.relation?.value!,
    connectedPepInfo: !isGlobal ? parsePepConnectionParam(values) : undefined,

    directCapitalParticipationPercentage: Number(
      values.controlOver.directCapitalParticipationPercentage
    ),

    financialConditionAmount:
      values.controlOver.financialConditionAmount ?? undefined,

    hasControlOverLegalClient:
      yesOrNot(values.controlOver.hasControlOverLegalClient?.value) ?? false,

    indirectCapitalParticipationPercentage: values.controlOver
      .indirectCapitalParticipationPercentage
      ? Number(values.controlOver.indirectCapitalParticipationPercentage)
      : null,
    additionalInformationFileIds: parseAdditionalInformationFileIdsParam(
      values.additionalDocumentsFiles
    ),
    additionalDocumentFileIds: parseAdditionalDocumentFileIdsParam(
      values.documentsFiles
    ),

    identityDocument: parseIdentityDocumentWithFilesParam(values),

    controlOverLegalClientStatus:
      values.controlOver.controlOverLegalClientStatus?.value,
  };
};
